// src/components/location/LocationDetails.styles.ts
import { StyleSheet } from "react-native";
import { FlickOColors } from "./color";
import { getResponsiveSize } from "./globalStyles";

export const styles = StyleSheet.create({
  mapContainer: {
    flex: 1,
    borderRadius: getResponsiveSize(8),
    overflow: "hidden",
  },
  coordinatesContainer: {
    flexDirection: "row",
    gap: getResponsiveSize(12),
    marginTop: getResponsiveSize(16),
  },
  permissionBanner: {
    backgroundColor: FlickOColors.background.light,
    borderRadius: getResponsiveSize(8),
    marginBottom: getResponsiveSize(16),
  },
  permissionText: {
    color: FlickOColors.text.primary,
    fontSize: getResponsiveSize(14),
    marginBottom: getResponsiveSize(8),
  },
  permissionButton: {
    backgroundColor: FlickOColors.primary,
    padding: getResponsiveSize(8),
    borderRadius: getResponsiveSize(4),
    alignItems: "center",
  },
  permissionButtonText: {
    color: FlickOColors.white,
    fontSize: getResponsiveSize(14),
    fontWeight: "500",
  },
  zoomControls: {
    position: "absolute",
    right: getResponsiveSize(16),
    top: getResponsiveSize(50), // Adjust this value
    zIndex: 999,
    height: getResponsiveSize(150), // Fixed height for button container
    justifyContent: "space-between",
  },
  zoomButton: {
    width: getResponsiveSize(40),
    height: getResponsiveSize(40),
    backgroundColor: FlickOColors.white,
    borderRadius: getResponsiveSize(20),
    justifyContent: "center",
    alignItems: "center",
    marginVertical: getResponsiveSize(8),
    elevation: 5,
  },
  zoomButtonText: {
    fontSize: getResponsiveSize(24),
    color: FlickOColors.text.primary,
    fontWeight: "500",
  },
});
